import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteByIdParatikaPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParatika/deleteByIdParatikaPosInsatallment',
      requesterInfo,
    })
  }

  public async deleteByIdParatikaPosInsatallment(request: number): Promise<CommonPostResponse> {
    this.props.url = `${this.props.url}?Id=${request}`
    return await this.postAsync<CommonPostResponse>()
  }
}

